import { library } from '@fortawesome/fontawesome-svg-core'
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons/faInfoCircle'
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons/faExclamationTriangle'
import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons/faExclamationCircle'
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons/faCheckCircle'

library.add(faInfoCircle, faExclamationCircle, faExclamationTriangle, faCheckCircle)
